import { DateTime } from "luxon"
import i18n from "@/i18n"

export function timeRange(startTime: DateTime | string, endTime: DateTime | string) {
  const start = startTime instanceof DateTime ? startTime : DateTime.fromISO(startTime)
  const end = endTime instanceof DateTime ? endTime : DateTime.fromISO(endTime)

  return `${start.toFormat(i18n.t("app.date.formats.time"))} - ${end.toFormat(i18n.t("app.date.formats.time"))}`
}

export const createHoursList = (day: DateTime | null, start: number, end: number, every: number = 15) => {
  if (!day) {
    return []
  }

  const startDate = day.startOf("day")

  const hours = Array.from({ length: (end < start ? end + 24 - start : end - start) + 1 }, (_, i) => (start + i) % 24)
  const minutes = Array.from({ length: 60 / every }, (_, i) => i * every)

  const value = (hour: number, minute: number) => {
    const label = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`
    const date = hour < start ? startDate.plus({ days: 1 }) : startDate

    return [label, date.set({ hour, minute })]
  }

  return hours.reduce((acc, hour) => {
    if (hour === end) {
      acc.push(value(hour, 0))
    } else {
      minutes.forEach((minute) => acc.push(value(hour, minute)))
    }
    return acc
  }, [])
}

export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600)
  const days = Math.floor(hours / 24)

  if (days > 0) {
    return i18n.t("app.date.duration.days", { count: days })
  }
  if (hours > 0) {
    return i18n.t("app.date.duration.hours", { count: hours })
  }
  const minutes = Math.floor(seconds / 60)
  return i18n.t("app.date.duration.minutes", { count: minutes })
}
